import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影资讯", to: "/category/film-info" },
  { label: "相关资讯", to: "/category/related-info" },
  { label: "观影指南", to: "/guide" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/category/film-info?q=${encodeURIComponent(q)}` : "/category/film-info");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-page items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
            <i className="ri-clapperboard-line text-lg"></i>
          </span>
          <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
            妈妈的职业电影
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-800"
                  : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form onSubmit={submitSearch} className="hidden items-center md:flex">
            <div className="flex h-10 items-center rounded-md border border-background-300 bg-background-50 pl-3 pr-1 focus-within:border-primary-400">
              <i className="ri-search-line text-base text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧情、演员与指南"
                className="h-full w-40 bg-transparent px-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400 lg:w-52"
              />
              <button
                type="submit"
                className="flex h-8 items-center rounded-md bg-accent-500 px-3 text-sm font-medium whitespace-nowrap text-white transition-colors hover:bg-accent-600"
              >
                搜索
              </button>
            </div>
          </form>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto max-w-page px-4 py-3">
            <form onSubmit={submitSearch} className="mb-3 flex items-center rounded-md border border-background-300 bg-background-50 pl-3 pr-1">
              <i className="ri-search-line text-base text-foreground-400"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧情、演员与指南"
                className="h-10 flex-1 bg-transparent px-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
              <button
                type="submit"
                className="flex h-8 items-center rounded-md bg-accent-500 px-3 text-sm font-medium whitespace-nowrap text-white"
              >
                搜索
              </button>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  onClick={() => setMenuOpen(false)}
                  className={`cursor-pointer rounded-md px-3 py-3 text-sm font-medium ${
                    isActive(item.to) ? "bg-primary-100 text-primary-800" : "text-foreground-700"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}